import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SuiContainer, SuiLabel } from '@splashthat/sui';

import FontPickerEditor from 'common/components/FontPicker';
import ColorPickerEditor from 'common/components/ColorPicker';
import { getColors } from 'common/entities/color/selectors';
import { getFonts } from 'common/entities/font/selectors';
import {
    getStepperPrimaryColor,
    getStepperSecondaryColor,
    getStepperFontStyles,
} from 'common/entities/form/styleConfiguration/selectors';
import {
    setFormStepperFont,
    setFormStepperFontSize,
    setFormStepperPrimaryColor,
    setFormStepperSecondaryColor,
} from 'common/entities/form/styleConfiguration/actions';

import { getFormId } from '../../../selectors';
import {
    STEPPER_FONT_LABEL,
    STEPPER_PRIMARY_COLOR_LABEL,
    STEPPER_SECONDARY_COLOR_LABEL,
} from '../../../constants/formStyleLabels';
import { COLLAPSIBLE_CONTENT, COLLAPSIBLE_SECTION } from '../../../constants/reusableClassNames';
import { STEPPER_QA } from '../../../utils/qaIdConstants';

const FormStyleEditorStepperPanel = () => {
    const dispatch = useDispatch();
    const formId = useSelector(getFormId);
    const colorList = useSelector(getColors);
    const fontList = useSelector(getFonts);
    const { font, fontSize } = useSelector((state) => getStepperFontStyles(state, formId));
    const primaryColor = useSelector((state) => getStepperPrimaryColor(state, formId));
    const secondaryColor = useSelector((state) => getStepperSecondaryColor(state, formId));

    return (
        <SuiContainer className={COLLAPSIBLE_CONTENT} data-qa={`${STEPPER_QA}--panel`}>
            <SuiContainer className={COLLAPSIBLE_SECTION} data-qa={`${STEPPER_QA}--section-font`}>
                <SuiLabel text={STEPPER_FONT_LABEL} />
                <FontPickerEditor
                    fontFamilyList={fontList}
                    defaultFontFamily={font}
                    onChangeFontFamily={(id) => dispatch(setFormStepperFont(formId, id))}
                    defaultFontSize={fontSize}
                    onChangeFontSize={(size) => dispatch(setFormStepperFontSize(formId, size))}
                    fontFamilyQa={`${STEPPER_QA}--fontFamily`}
                    fontSizeQa={`${STEPPER_QA}--fontSize`}
                />
            </SuiContainer>
            <SuiContainer className={COLLAPSIBLE_SECTION} data-qa={`${STEPPER_QA}--section-primary-color`}>
                <SuiLabel text={STEPPER_PRIMARY_COLOR_LABEL} />
                <ColorPickerEditor
                    colorList={colorList}
                    firstColor={primaryColor}
                    changeFirstColor={(id) => dispatch(setFormStepperPrimaryColor(formId, id))}
                    qaId={STEPPER_QA}
                />
            </SuiContainer>
            <SuiContainer className={COLLAPSIBLE_SECTION} data-qa={`${STEPPER_QA}--section-secondary-color`}>
                <SuiLabel text={STEPPER_SECONDARY_COLOR_LABEL} />
                <ColorPickerEditor
                    colorList={colorList}
                    firstColor={secondaryColor}
                    changeFirstColor={(id) => dispatch(setFormStepperSecondaryColor(formId, id))}
                    qaId={STEPPER_QA}
                />
            </SuiContainer>
        </SuiContainer>
    );
};

export default FormStyleEditorStepperPanel;
